interface TransactionsTypeBadgeProps {
}

const TransactionsTypeBadge = ({type}:{type: number}) => {

  const styles = [
    'bg-green-500',
    'bg-indigo-500',
    'bg-purple-500',
    'bg-gray-500',
  ]

  const bgColors = [
    'bg-green-50 text-green-950',
    'bg-indigo-50 text-indigo-950',
    'bg-purple-50 text-purple-950',
    'bg-gray-50 text-gray-950',

  ]

  const labels = [
    'Assegnati',
    'Traguardo',
    'Buono sconto',
    'Reset Punti'
  ]

  return (
    <div className={` rounded-full px-2 py-1 text-xs font-medium w-fit flex items-center gap-1 ${bgColors[type]}`}>
      <div className={`${styles[type]} rounded-full h-2 w-2 mr-1`}/>
      {labels[type] || 'N/A'}
    </div>
  );
};
export default TransactionsTypeBadge;
